/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'feedback-collector.anonymous': 'Palaute lähetetään anonyymisti. Atlassian ei voi ottaa yhteyttä suoraan sinuun tämän palautteen perusteella.',
  'feedback-collector.anonymous.title': 'Anonyymi palaute',
  'feedback-collector.can-be-contacted.label': 'Kyllä, Atlassian-tiimit voivat ottaa minuun yhteyttä ja pyytää lisätietoja kokemuksistani Atlassian-tuotteiden ja ‑palveluiden parantamista varten. Hyväksyn <a>Atlassianin tietosuojakäytännön</a>.',
  'feedback-collector.cancel-button.label': 'Peruuta',
  'feedback-collector.default.custom.textarea.label': 'Mitä mietit?',
  'feedback-collector.enrol-in-research.label': 'Haluan osallistua tuotetutkimukseen',
  'feedback-collector.feedback-title': 'Jaa ajatuksesi',
  'feedback-collector.form.bug.label': 'Kuvaile bugia tai ongelmaa',
  'feedback-collector.form.comment.label': 'Kerro meille, mitä sinulla on mielessä',
  'feedback-collector.form.empty.label': 'Valitse vaihtoehto',
  'feedback-collector.form.question.label': 'Mitä haluat tietää?',
  'feedback-collector.form.suggestion.label': 'Kerro meille, mitä haluaisit parantaa',
  'feedback-collector.option.bug.label': 'ilmoittaa bugista',
  'feedback-collector.option.comment.label': 'jättää kommentin',
  'feedback-collector.option.default.label': 'Valitse palaute',
  'feedback-collector.option.default.placeholder': 'Valitse yksi',
  'feedback-collector.option.question.label': 'esittää kysymyksen',
  'feedback-collector.option.suggestion.label': 'ehdottaa parannusta',
  'feedback-collector.required.fields.summary': 'Pakolliset kentät on merkitty tähdellä',
  'feedback-collector.submit-button.label': 'Lähetä palaute',
  'feedback-collector.success-flag.description': 'Arvokkaan palautteesi avulla voimme jatkuvasti parantaa tuotteitamme.',
  'feedback-collector.success-flag.title': 'Kiitos!',
  'feedback-collector.summary-placeholder': 'Kerro meille, mitä sinulla on mielessä',
  'proforma-form-builder.feedback-icon-label': 'Palaute',
  'proforma-form-builder.give-feedback': 'Anna palautetta'
};